export const HomeModuleConsts = {
    PHONE_NUMBER: /^\+?(44)?(0|7)\d{9,13}$/,
    UK_NUMBER:/^((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}/,
    HOME_PAGE_TITLE: 'World of Sweets',
    USER_TYPE_RETAILER:2,
    USER_TYPE_STORE_MEMBER:3,
    USER_TYPES_INCLUDED:[2, 3],
    BI_TRACKING_IDENTIFIER_TOADD: 1,
    BI_TRACKING_IDENTIFIER_TOREMOVE: 3,
    BI_TRACKING_IDENTIFIER_NOTINTERESTED: 2
}

export const BRANDNAMES = {
    A_TO_E :'Brands A-E',
    F_TO_J :'Brands F-J',
    K_TO_O :'Brands K-O',
    P_TO_U :'Brands P-U',
    V_TO_Z :'Brands V-Z',
    BRAND :'Brands #'
}


  
  
